













































import { Component } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import { AlertMessage, ErrorMessage, userApi } from '@/api'
import {
  alertStore,
  dataStore,
  modalErrorStore,
  reWriteCardStore,
  systemParameterStore
} from '@/utils/store-accessor'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import CODE_KEY from '@/config/code_key'
import { setErrorMessage } from '@/utils/error'
import { AlertFactory } from '@/factory'
import {
  AlertCodeALC00012,
  AlertCodeCLT00033,
  AlertCodeCLT00034
} from '@/types'
import { InputUserId } from '@/components/molecules/InputUserId'

interface ModalUserCardReissueInterface {
  userId: string
  onUpdated: (newUserId: string) => void
  onCanceled: () => void
}

interface ModalUserCardReissueItem {
  dialog: boolean
  oldUserId: string
  newUserId: {
    input: string
    errorMessage: string
  }
  onUpdated: (newUserId: string) => void
  onCanceled: () => void
}

const defaultModalUserCardReissueItem = (): ModalUserCardReissueItem => ({
  dialog: false,
  oldUserId: '',
  newUserId: {
    input: '',
    errorMessage: ''
  },
  onUpdated: () => {},
  onCanceled: () => {}
})

@Component({
  components: {
    InputUserId,
    ModalFooter
  }
})
export default class ModalUserCardReissue extends ComponentVue {
  item: ModalUserCardReissueItem = defaultModalUserCardReissueItem()

  get enabledReWriteCard(): boolean {
    return dataStore.enabledReWriteCard && this.$webSocket.reWriteCardEnabled
  }

  open(params: ModalUserCardReissueInterface): void {
    this.item = Object.assign(defaultModalUserCardReissueItem(), {
      dialog: true,
      oldUserId: params.userId,
      onUpdated: params.onUpdated,
      onCanceled: params.onCanceled
    })

    systemParameterStore.fetchAllAndMergeByCodeKeys([
      CODE_KEY.NUMBER_MANAGEMENT.KEY
    ])
  }

  cancel(): void {
    this.item.onCanceled()
    this.initialize()
  }

  initialize(): void {
    this.item = defaultModalUserCardReissueItem()
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  update() {
    let update: Function = async (_updateCardLostCount: boolean = true) => {
      this.$eventBus.emit(PAGE_LOADING_START)

      try {
        await userApi.userCardReissue({
          id: this.item.oldUserId,
          userId: this.item.newUserId.input,
          _updateCardLostCount
        })

        this.$eventBus.emit(PAGE_LOADING_END)

        this.item.onUpdated(this.item.newUserId.input)

        this.initialize()
      } catch (error) {
        this.$eventBus.emit(PAGE_LOADING_END)
        if (error instanceof AlertMessage) {
          setErrorMessage(error.alerts, {
            userId: this.item.newUserId
          })
          alertStore.setItems(error.alerts)
          this.$modalAlert.open()
        } else if (error instanceof ErrorMessage) {
          modalErrorStore.init(error)
          this.$modalError.open()
        } else {
          console.error(error)
        }
      }
    }

    if (dataStore.displayCardLostCountUpdateAlertOnUserCardReissue) {
      const originalUpdate = update
      update = () => {
        alertStore.setItem(
          AlertFactory.create(AlertCodeALC00012, '紛失回数の更新')
        )
        this.$modalAlert.open({
          onOkClick: originalUpdate,
          onCancelClick: () => originalUpdate(false)
        })
      }
    }

    if (!this.$webSocket.reWriteCardEnabled) {
      update()
      return
    }

    if (reWriteCardStore.registered) {
      alertStore.setItem(AlertFactory.create(AlertCodeCLT00033))
      this.$modalAlert.open({
        onOkClick: update
      })
      return
    }

    if (!reWriteCardStore.loaded) {
      alertStore.setItem(AlertFactory.create(AlertCodeCLT00034))
      this.$modalAlert.open({
        onOkClick: update
      })

      return
    }

    update()
  }
}
